import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { type MotionNodeDraggableOptions, type PanInfo, motion } from 'framer-motion';
export interface SwipeThreshold {
  x?: number;
  y?: number;
}
export type SwipeFunction = (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => void;
export interface SwipeableActions {
  swipe?: SwipeFunction;
  swipeHorizontal?: SwipeFunction;
  swipeVertical?: SwipeFunction;
  swipeLeft?: SwipeFunction;
  swipeRight?: SwipeFunction;
  swipeUp?: SwipeFunction;
  swipeDown?: SwipeFunction;
}
export interface SwipeableProps {
  actions: SwipeableActions;
  children: ReactNode;
  className?: string;
  options?: MotionNodeDraggableOptions;
  threshold?: SwipeThreshold;
}
const DEFAULT_DRAG = true;
const DEFAULT_DRAG_CONSTRAINTS = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
};
const DEFAULT_DRAG_ELASTIC = 0.9;
const DEFAULT_DRAG_MOMENTUM = false;
const DEFAULT_DRAG_DIRECTION_LOCK = true;
const DEFAULT_DRAG_TRANSITION = {
  bounceStiffness: 400,
  bounceDamping: 50
};
const DEFAULT_THRESHOLD = {
  x: 50,
  y: 100
};
export function Swipeable(t0) {
  const $ = _c(15);
  const {
    actions,
    children,
    className,
    options,
    threshold: t1
  } = t0;
  const threshold = t1 === undefined ? DEFAULT_THRESHOLD : t1;
  let t2;
  if ($[0] !== actions || $[1] !== threshold.x || $[2] !== threshold.y) {
    t2 = (event, info) => {
      const x = info.offset.x;
      const y = info.offset.y;
      const tx = threshold.x ?? DEFAULT_THRESHOLD.x;
      const ty = threshold.y ?? DEFAULT_THRESHOLD.y;
      const absX = Math.abs(x);
      const absY = Math.abs(y);
      if (absX < tx && absY < ty) {
        return;
      }
      actions.swipe?.(event, info);
      if (absX > absY) {
        actions.swipeHorizontal?.(event, info);
        if (x < 0) {
          actions.swipeLeft?.(event, info);
        } else {
          actions.swipeRight?.(event, info);
        }
      } else {
        actions.swipeVertical?.(event, info);
        if (y < 0) {
          actions.swipeUp?.(event, info);
        } else {
          actions.swipeDown?.(event, info);
        }
      }
    };
    $[0] = actions;
    $[1] = threshold.x;
    $[2] = threshold.y;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onDragEnd = t2;
  const t3 = options?.drag || DEFAULT_DRAG;
  const t4 = options?.dragConstraints || DEFAULT_DRAG_CONSTRAINTS;
  const t5 = options?.dragDirectionLock || DEFAULT_DRAG_DIRECTION_LOCK;
  const t6 = options?.dragElastic || DEFAULT_DRAG_ELASTIC;
  const t7 = options?.dragMomentum || DEFAULT_DRAG_MOMENTUM;
  const t8 = options?.dragTransition || DEFAULT_DRAG_TRANSITION;
  let t9;
  if ($[4] !== children || $[5] !== className || $[6] !== onDragEnd || $[7] !== options || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== t8) {
    t9 = <motion.div {...options} drag={t3} dragConstraints={t4} dragDirectionLock={t5} dragElastic={t6} dragMomentum={t7} dragTransition={t8} onDragEnd={onDragEnd} className={className}>{children}</motion.div>;
    $[4] = children;
    $[5] = className;
    $[6] = onDragEnd;
    $[7] = options;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}